import { client } from './client'

export type ChangeSetStatus = 'Pending' | 'Applied' | 'Superseded' | 'Discarded'
export type ChangeSetItemOperation = 'Create' | 'Update'
export type ChangeSetItemDecision = 'Staged' | 'Unstaged' | 'Discarded'
export type ChangeSetRoundDecision = Exclude<ChangeSetItemDecision, 'Discarded'>
export type ChangeSetItemRevision = 'Unchanged' | 'Revised' | 'New'
export type ChangeSetEntityKind = 'Intent' | 'WorkItem' | 'TestCase' | 'TestPlan' | 'Document'

export interface WorkflowChangeSetItem {
  id: string
  entityKind: ChangeSetEntityKind
  operation: ChangeSetItemOperation
  targetEntityId: string
  title: string
  proposedValuesJson: string
  beforeValuesJson: string | null
  decision: ChangeSetItemDecision
  revision: ChangeSetItemRevision
  itemIndex: number
}

export interface WorkflowChangeSet {
  id: string
  workflowRunId: string
  producingPhaseId: string
  stagedByNodeId: string
  round: number
  status: ChangeSetStatus
  stagedAt: string
  appliedAt: string | null
  feedbackAvailable: boolean
  items: WorkflowChangeSetItem[]
}

export interface WorkflowGateFeedback {
  id: string
  gatePhaseId: string
  supersededRound: number
  message: string
  submittedByUserId: string | null
  submittedAt: string
}

export interface WorkflowRunChangeSets {
  gateFeedbackAvailable: boolean
  changeSets: WorkflowChangeSet[]
  feedbackRounds: WorkflowGateFeedback[]
}

export const workflowChangeSetsApi = {
  getChangeSets: (projectId: string, runId: string) =>
    client
      .get<WorkflowRunChangeSets>(`/projects/${projectId}/workflow-runs/${runId}/change-sets`)
      .then((r) => r.data),

  setRoundDecision: (
    projectId: string,
    runId: string,
    changeSetId: string,
    decision: ChangeSetRoundDecision,
  ) =>
    client
      .post(`/projects/${projectId}/workflow-runs/${runId}/change-sets/${changeSetId}/decision`, { decision })
      .then((r) => r.data),

  setItemDecision: (
    projectId: string,
    runId: string,
    changeSetId: string,
    itemId: string,
    decision: ChangeSetItemDecision,
  ) =>
    client
      .post(
        `/projects/${projectId}/workflow-runs/${runId}/change-sets/${changeSetId}/items/${itemId}/decision`,
        { decision },
      )
      .then((r) => r.data),

  editItemProposedContent: (
    projectId: string,
    runId: string,
    changeSetId: string,
    itemId: string,
    proposedValuesJson: string,
  ) =>
    client
      .post(
        `/projects/${projectId}/workflow-runs/${runId}/change-sets/${changeSetId}/items/${itemId}/proposed-content`,
        { proposedValuesJson },
      )
      .then((r) => r.data),

  submitGateFeedback: (projectId: string, runId: string, message: string) =>
    client
      .post(`/projects/${projectId}/workflow-runs/${runId}/gate-feedback`, { message })
      .then((r) => r.data),
}
